import Helper from './Helper';

class LinkTargetHandler {
  constructor(config = {}) {
    const {
      linkSelector
    } = config;

    const links = Array.prototype.slice.call(document.querySelectorAll(linkSelector));
    links.forEach(link =>{
      link.setAttribute('target', '_blank');
    });
  }
} export default LinkTargetHandler;
